!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports, require("react"), require("antd")) : "function" == typeof define && define.amd ? define(["exports", "react", "antd"], n) : n((e = e || self).LandingPage = {}, e.React, e.antd);
}(this, function (e, n, t) {
  "use strict";

  var r = "default" in n ? n.default : n;

  function o(e, n) {
    for (var t = 0; t < n.length; t++) {
      var r = n[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function i(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  function a() {
    return (a = Object.assign || function (e) {
      for (var n = 1; n < arguments.length; n++) {
        var t = arguments[n];

        for (var r in t) {
          Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function c(e) {
    return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function l(e, n) {
    return (l = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function s(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function u(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function f(e, n) {
    return e(n = {
      exports: {}
    }, n.exports), n.exports;
  }

  var p = f(function (e, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var t = "function" == typeof Symbol && Symbol.for,
        r = t ? Symbol.for("react.element") : 60103,
        o = t ? Symbol.for("react.portal") : 60106,
        i = t ? Symbol.for("react.fragment") : 60107,
        a = t ? Symbol.for("react.strict_mode") : 60108,
        c = t ? Symbol.for("react.profiler") : 60114,
        l = t ? Symbol.for("react.provider") : 60109,
        s = t ? Symbol.for("react.context") : 60110,
        u = t ? Symbol.for("react.async_mode") : 60111,
        f = t ? Symbol.for("react.concurrent_mode") : 60111,
        p = t ? Symbol.for("react.forward_ref") : 60112,
        d = t ? Symbol.for("react.suspense") : 60113,
        y = t ? Symbol.for("react.memo") : 60115,
        g = t ? Symbol.for("react.lazy") : 60116;

    function m(e) {
      if ("object" == typeof e && null !== e) {
        var n = e.$$typeof;

        switch (n) {
          case r:
            switch (e = e.type) {
              case u:
              case f:
              case i:
              case c:
              case a:
              case d:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case s:
                  case p:
                  case l:
                    return e;

                  default:
                    return n;
                }

            }

          case g:
          case y:
          case o:
            return n;
        }
      }
    }

    function b(e) {
      return m(e) === f;
    }

    n.typeOf = m, n.AsyncMode = u, n.ConcurrentMode = f, n.ContextConsumer = s, n.ContextProvider = l, n.Element = r, n.ForwardRef = p, n.Fragment = i, n.Lazy = g, n.Memo = y, n.Portal = o, n.Profiler = c, n.StrictMode = a, n.Suspense = d, n.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === f || e === c || e === a || e === d || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === y || e.$$typeof === l || e.$$typeof === s || e.$$typeof === p);
    }, n.isAsyncMode = function (e) {
      return b(e) || m(e) === u;
    }, n.isConcurrentMode = b, n.isContextConsumer = function (e) {
      return m(e) === s;
    }, n.isContextProvider = function (e) {
      return m(e) === l;
    }, n.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === r;
    }, n.isForwardRef = function (e) {
      return m(e) === p;
    }, n.isFragment = function (e) {
      return m(e) === i;
    }, n.isLazy = function (e) {
      return m(e) === g;
    }, n.isMemo = function (e) {
      return m(e) === y;
    }, n.isPortal = function (e) {
      return m(e) === o;
    }, n.isProfiler = function (e) {
      return m(e) === c;
    }, n.isStrictMode = function (e) {
      return m(e) === a;
    }, n.isSuspense = function (e) {
      return m(e) === d;
    };
  });
  u(p);
  p.typeOf, p.AsyncMode, p.ConcurrentMode, p.ContextConsumer, p.ContextProvider, p.Element, p.ForwardRef, p.Fragment, p.Lazy, p.Memo, p.Portal, p.Profiler, p.StrictMode, p.Suspense, p.isValidElementType, p.isAsyncMode, p.isConcurrentMode, p.isContextConsumer, p.isContextProvider, p.isElement, p.isForwardRef, p.isFragment, p.isLazy, p.isMemo, p.isPortal, p.isProfiler, p.isStrictMode, p.isSuspense;
  var d = f(function (e, n) {});
  u(d);
  d.typeOf, d.AsyncMode, d.ConcurrentMode, d.ContextConsumer, d.ContextProvider, d.Element, d.ForwardRef, d.Fragment, d.Lazy, d.Memo, d.Portal, d.Profiler, d.StrictMode, d.Suspense, d.isValidElementType, d.isAsyncMode, d.isConcurrentMode, d.isContextConsumer, d.isContextProvider, d.isElement, d.isForwardRef, d.isFragment, d.isLazy, d.isMemo, d.isPortal, d.isProfiler, d.isStrictMode, d.isSuspense, f(function (e) {
    e.exports = p;
  });
  var y = Object.getOwnPropertySymbols,
      g = Object.prototype.hasOwnProperty,
      m = Object.prototype.propertyIsEnumerable;
  (function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var n = {}, t = 0; t < 10; t++) {
        n["_" + String.fromCharCode(t)] = t;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  })() && Object.assign;
  var b = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  Function.call.bind(Object.prototype.hasOwnProperty);

  function h() {}

  function v() {}

  v.resetWarningCache = h;
  var x = f(function (e) {
    e.exports = function () {
      function e(e, n, t, r, o, i) {
        if (i !== b) {
          var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw a.name = "Invariant Violation", a;
        }
      }

      function n() {
        return e;
      }

      e.isRequired = e;
      var t = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: n,
        element: e,
        elementType: e,
        instanceOf: n,
        node: e,
        objectOf: n,
        oneOf: n,
        oneOfType: n,
        shape: n,
        exact: n,
        checkPropTypes: v,
        resetWarningCache: h
      };
      return t.PropTypes = t, t;
    }();
  });
  !function (e, n) {
    void 0 === n && (n = {});
    var t = n.insertAt;

    if (e && "undefined" != typeof document) {
      var r = document.head || document.getElementsByTagName("head")[0],
          o = document.createElement("style");
      o.type = "text/css", "top" === t && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
    }
  }(".landing-page {\n  height: 100vh;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  color: floralwhite;\n}\n\n.landing-page .logo {\n  min-width: 125px;\n  margin: 20px;\n  width: 15%;\n  position: absolute;\n}\n.landing-page .logo img {\n  width: 100%;\n}\n\n.landing-page .overlay {\n  background: rgba(0, 0, 0, 0.7);\n  height: 100vh;\n}\n\n.landing-page .content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: calc(100% - 90px);\n  padding: 20px;\n}\n\n.landing-page h2 {\n  color: floralwhite;\n  margin: 0;\n  font-size: 36px;\n  text-align: center;\n  line-height: 1em;\n}\n\n.landing-page .error {\n  max-width: 450px;\n}\n\n.landing-page button {\n  margin: 15px 0;\n}\n\n.landing-page button {\n  border-color: #cbce12 !important;\n  color: floralwhite !important;\n}\n\n.landing-page footer {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.65);\n  height: 90px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.landing-page footer ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  flex: 1;\n}\n\n.landing-page footer ul li {\n  padding: 0 20px;\n}\n\n.landing-page footer ul li a {\n  color: floralwhite;\n}\n\n.landing-page footer img {\n  margin: 20px;\n  width: 90px;\n}\n");

  var O = function (e) {
    function u() {
      var e, n, t, r;
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, u);

      for (var o = arguments.length, a = new Array(o), l = 0; l < o; l++) {
        a[l] = arguments[l];
      }

      return t = this, n = !(r = (e = c(u)).call.apply(e, [this].concat(a))) || "object" != typeof r && "function" != typeof r ? s(t) : r, i(s(n), "state", {}), n;
    }

    var f, p, d;
    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && l(e, n);
    }(u, n.Component), f = u, (p = [{
      key: "componentDidMount",
      value: function value() {
        var e = this.props.onMount;
        e && e();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            n = e.title,
            o = e.background,
            i = e.logo,
            c = e.overlay,
            l = e.footerItems,
            s = e.handleLogin,
            u = e.welcomeMessage,
            f = e.loading,
            p = e.error;
        return r.createElement("div", {
          className: "landing-page",
          style: {
            backgroundImage: "url(".concat(o, ")")
          }
        }, r.createElement("div", {
          className: "logo"
        }, i), r.createElement("div", {
          className: c ? "overlay" : ""
        }, r.createElement("div", {
          className: "content"
        }, r.createElement("h2", null, n), u, r.createElement(t.Button, {
          loading: f,
          size: "large",
          type: "ghost",
          ghost: "true",
          onClick: s
        }, f ? "Logging in ..." : "Click here to ".concat(p ? "try again" : "log in")), !f && p && r.createElement(t.Alert, a({
          className: "error",
          showIcon: !0
        }, p)))), r.createElement("footer", null, r.createElement("ul", {
          key: "items"
        }, l.map(function (e, n) {
          return r.createElement("li", {
            key: "footer_".concat(n)
          }, e);
        }))));
      }
    }]) && o(f.prototype, p), d && o(f, d), u;
  }();

  i(O, "propTypes", {
    title: x.string.isRequired,
    background: x.string.isRequired,
    logo: x.node.isRequired,
    welcomeMessage: x.node,
    footerItems: x.arrayOf(x.node),
    loading: x.bool,
    error: x.shape({
      type: x.string,
      message: x.oneOfType([x.string, x.node])
    }),
    overlay: x.bool,
    onMount: x.func
  }), i(O, "defaultProps", {
    overlay: !0,
    footerItems: [],
    loading: !1
  }), e.LandingPage = O, e.default = O;
});